import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ScrollToTop from "../../components/ui/ScrollToTop";
import SEO from "../../components/SEO";

const serviciosTopografia = [
    {
        titulo: "Plano Topográfico",
        desc: "Representación detallada del relieve del terreno.",
        link: "/servicios/topografia/plano-topografico",
        img: "/img/topografia.jpg"
    },
    {
        titulo: "Plano Perimétrico",
        desc: "Delimitación precisa de los linderos del terreno.",
        link: "/servicios/topografia/plano-perimetrico",
        img: "/img/perimetrico.jpg"
    },
    {
        titulo: "Subdivisión de Terreno",
        desc: "División legal del predio en lotes independientes.",
        link: "/servicios/topografia/subdivision",
        img: "/img/subdivision.jpg"
    },
    {
        titulo: "Levantamiento Topográfico",
        desc: "Captura precisa de puntos del terreno.",
        link: "/servicios/topografia/levantamiento",
        img: "/img/levantamiento.jpg"
    },
    {
        titulo: "Levantamiento Fotogramétrico",
        desc: "Uso de drones para modelado del terreno.",
        link: "/servicios/topografia/fotogrametria",
        img: "/img/drone.jpg"
    },
    {
        titulo: "Parcelaciones",
        desc: "División de terrenos en parcelas.",
        link: "/servicios/topografia/parcelacion",
        img: "/img/parcelacion.jpg"
    },
    {
        titulo: "Replanteo de Lotes",
        desc: "Marcación en campo del diseño del lote.",
        link: "/servicios/topografia/replanteo",
        img: "/img/replanteo.jpg"
    },
    {
        titulo: "Cálculo de Área y Perímetro",
        desc: "Determinación exacta de superficies.",
        link: "/servicios/topografia/calculo-area",
        img: "/img/area.jpg"
    },
    {
        titulo: "Nivelaciones",
        desc: "Control de alturas en proyectos.",
        link: "/servicios/topografia/nivelaciones",
        img: "/img/nivelacion.jpg"
    },
    {
        titulo: "Trazado y Lotizaciones",
        desc: "Diseño y marcado de urbanizaciones.",
        link: "/servicios/topografia/lotizacion",
        img: "/img/lotizacion.jpg"
    }
];

export default function ServiciosTopografiaPage() {
    return (
        <>
            <SEO
                title="Servicios de Topografía con Drones y Estación Total | Planix Lima"
                description="Especialistas en levantamiento topográfico, fotogrametría con drones, replanteo de lotes y planos perimétricos. Precisión milimétrica para proyectos en San Juan de Lurigancho y todo el Perú."
                keywords="levantamiento topográfico, fotogrametría drones lima, replanteo de lotes, plano perimétrico sjl, curvas de nivel, georreferenciación sunarp"
                canonical="https://www.planixapp.com/servicios/topografia"
                schema={{
                    "@context": "https://schema.org",
                    "@type": "Service",
                    "serviceType": "Topografía",
                    "provider": {
                        "@type": "Organization",
                        "name": "Planix"
                    },
                    "areaServed": {
                        "@type": "Country",
                        "name": "Perú"
                    }
                }}
            />

            <ScrollToTop />

            <section className="bg-gray-50 py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    {/* HEADER */}
                    <div className="text-center max-w-2xl mx-auto mb-16">
                        <span className="text-[#F26B1D] font-bold tracking-[0.2em] text-xs uppercase block mb-4">
                            Ingeniería de Precisión
                        </span>
                        <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900">
                            Todos nuestros <span className="text-[#F26B1D]">Servicios</span>
                        </h1>
                        <p className="text-gray-500 mt-6 text-lg">
                            Explora cada uno de nuestros servicios topográficos con tecnología moderna y máxima precisión.
                        </p>
                    </div>

                    {/* GRID DE TARJETAS */}
                    <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        {serviciosTopografia.map((servicio, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.05 }}
                                whileHover={{ y: -10 }}
                                className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col overflow-hidden"
                            >
                                {/* Imagen */}
                                <div className="relative h-48 overflow-hidden">
                                    <img
                                        src={servicio.img}
                                        alt={servicio.titulo}
                                        className="w-full h-full object-cover transition duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent opacity-0 group-hover:opacity-100 transition duration-500" />
                                </div>

                                {/* Contenido */}
                                <div className="p-6 flex flex-col flex-grow">

                                    <h3 className="text-lg font-bold text-gray-900 group-hover:text-[#F26B1D] transition min-h-[48px] line-clamp-2">
                                        {servicio.titulo}
                                    </h3>

                                    <p className="text-gray-500 mt-3 text-sm line-clamp-3 min-h-[60px]">
                                        {servicio.desc}
                                    </p>

                                    <div className="mt-auto pt-5 border-t border-gray-100">
                                        <Link
                                            to={servicio.link}
                                            className="inline-flex items-center text-sm font-bold text-[#F26B1D] group/link"
                                        >
                                            Saber más
                                            <span className="ml-2 group-hover/link:translate-x-1 transition-transform">
                                                →
                                            </span>
                                        </Link>
                                    </div>

                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}